import { render, staticRenderFns } from "./DialogSendEmail.vue?vue&type=template&id=48b91dba&"
import script from "./DialogSendEmail.vue?vue&type=script&lang=js&"
export * from "./DialogSendEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports